import VideoJS from 'video.js';

export var Component = function (name, classes, iconHTML) {
	var Component = VideoJS.getComponent('Component');
	var ASIcon = VideoJS.extend(Component, {});

	ASIcon.prototype.createEl = function () {
	    return Component.prototype.createEl.call(this, 'span', {
	        className: classes,
	        innerHTML: iconHTML
	    });
	};

	VideoJS.registerComponent(name, ASIcon);

	return name;
};



// WEBPACK FOOTER //
// ./src/player/controls/component.js